import React from "react";
import User from "./User";
import { Link } from "react-router-dom";
import RegistrationLink from "./RegistrationLink";
import { getFilteredUsers } from "../Selectors/users";

function UserTask(props) {
  const filteredUsers = getFilteredUsers(props.users, props.auth.email);

  if (props.auth.authenticated === false) {
    return <RegistrationLink />;
  }
  return (
    <div className="container">
      <Link className="btn btn-primary" to="/AddUser">
        Add User
      </Link>

      <div className="row">
        {filteredUsers
          .sort((x, y) => {
            return y.id - x.id;
          })
          .map((user, index) => (
            <User key={index} user={user} {...props} index={index} />
          ))}
      </div>
    </div>
  );
}

export default UserTask;
